import styles from "./index.module.css";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";

export default function ContactOffer() {
  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.offercontainer}>
        <h1>ПУБЛІЧНА ОФЕРТА</h1>
        <p className="subtitle">
          про надання освітньо-інформаційних послуг у межах сезонного
          онлайн-інтенсиву Profound English Community
        </p>
        <p>
          Цей документ є офіційною публічною пропозицією Фізичної
          особи-підприємця Кошкіної Марії Михайлівни укласти Договір про надання
          освітньо-інформаційних послуг у межах сезонного онлайн-інтенсиву
          Profound English Community на умовах, викладених нижче.
        </p>
        <p>
          Ця Публічна оферта адресована будь-якій фізичній особі, яка має намір
          замовити послуги для себе або для іншої особи, зокрема неповнолітньої
          особи віком від 16 років.
        </p>
        <p>
          Акцепт цієї Оферти означає повне та безумовне прийняття Замовником
          усіх умов цього Договору.
        </p>
        <h2>1. Терміни та визначення</h2>
        <p>
          1.1. <strong>Виконавець</strong> — Фізична особа-підприємець Кошкіна
          Марія Михайлівна, яка надає освітньо-інформаційні послуги в межах
          сезонного онлайн-інтенсиву Profound English Community.
        </p>
        <p>
          1.2. <strong>Замовник</strong> — фізична особа, яка здійснює запис на
          інтенсив, приймає умови цієї Оферти та/або здійснює оплату послуг.
          Якщо Отримувач послуг є неповнолітньою особою, Замовником виступає
          один із батьків або інший законний представник такої особи.
        </p>
        <p>
          1.3. <strong>Отримувач послуг / Учасник інтенсиву</strong> — особа,
          яка безпосередньо бере участь у заняттях інтенсиву.
        </p>
        <p>
          1.4. <strong>Інтенсив</strong> — сезонний онлайн-інтенсив Profound
          English Community, що передбачає проведення живих онлайн-занять з
          англійської мови відповідно до програми, графіка та умов, визначених
          Виконавцем.
        </p>
        <p>
          1.5. <strong>Оферта</strong> — цей документ, розміщений на сайті
          Виконавця або наданий Замовнику іншим способом, який містить умови
          надання послуг.
        </p>
        <p>
          1.6. <strong>Акцепт Оферти</strong> — повне та безумовне прийняття
          Замовником умов цієї Оферти шляхом вчинення дій, передбачених цим
          Договором, зокрема здійснення повної або часткової оплати послуг.
        </p>
        <p>
          1.7. <strong>Сайт Виконавця</strong> — вебсторінка або вебресурс, на
          якому розміщено інформацію про інтенсив, тестування, графік, вартість,
          умови участі та/або посилання на цю Оферту.
        </p>
        <p>
          1.8. <strong>Платформа</strong> — онлайн-сервіси, які використовуються
          для проведення інтенсиву, зокрема Zoom, Edio або інші платформи,
          визначені Виконавцем.
        </p>
        <h2>2. Предмет Договору</h2>
        <p>
          2.1. Виконавець зобов’язується надати Замовнику/Отримувачу послуг
          доступ до участі в сезонному онлайн-інтенсиві Profound English
          Community, а Замовник зобов’язується оплатити такі послуги та
          дотримуватися умов цього Договору.
        </p>
        <p>
          2.2. Послуги надаються в онлайн-форматі шляхом проведення живих занять
          з викладачем, надання навчальних матеріалів, домашніх завдань, доступу
          до записів занять, організації фінального тестування та, за умови
          виконання вимог цього Договору, видачі внутрішнього сертифіката
          Profound English Community.
        </p>
        <p>
          2.3. Ця Оферта регулює виключно порядок надання послуг у межах живого
          сезонного онлайн-інтенсиву Profound English Community.
        </p>
        <p>
          2.4. Ця Оферта не поширюється на самостійне опрацювання курсу,
          Speaking Club, індивідуальні заняття, стандартні групові заняття або
          інші освітні продукти Виконавця, якщо інше прямо не зазначено
          Виконавцем.
        </p>
        <h2>3. Формат, тривалість та структура інтенсиву</h2>
        <p>
          3.1. Інтенсив проводиться в онлайн-форматі з використанням платформи
          Zoom, Edio або інших онлайн-інструментів, визначених Виконавцем.
        </p>
        <p>
          3.2. Основним форматом інтенсиву є групове навчання у групах до 6
          учасників.
        </p>
        <p>
          3.3. Якщо до початку інтенсиву група відповідного рівня, графіка або
          сезону не сформована, Виконавець має право запропонувати Замовнику
          альтернативний формат навчання, зокрема дуо-формат із 2 учасниками.
        </p>
        <p>
          3.4. У разі відмови Замовника від запропонованого альтернативного
          формату, якщо група не була сформована з боку Виконавця, Виконавець
          повертає Замовнику сплачені кошти.
        </p>
        <p>
          3.5. Інтенсив передбачає проведення 52 навчальних занять для кожного
          учасника.
        </p>
        <p>3.6. Тривалість одного заняття становить 60 хвилин.</p>
        <p>
          3.7. Заняття проводяться з понеділка по четвер відповідно до
          затвердженого графіка відповідної групи або дуо.
        </p>
        <p>
          3.8. Доступні часові слоти можуть включати 10:00 або 20:00, а також
          інші години, визначені Виконавцем залежно від сезону, рівня групи та
          організаційних можливостей.
        </p>
        <p>
          3.9. Інтенсив триває протягом відповідного сезону. Орієнтовні сезонні
          періоди:
        </p>
        <p>весняний інтенсив: з 1 березня по 31 травня;</p>
        <p>літній інтенсив: з 1 червня по 31 серпня;</p>
        <p>осінній інтенсив: з 1 вересня по 30 листопада;</p>
        <p>зимовий інтенсив: з 1 грудня по останній календарний день лютого.</p>
        <p>
          3.10. Конкретні дати проведення відповідного сезону інтенсиву
          зазначаються на сайті Виконавця, у повідомленні Виконавця, у процесі
          запису або в іншому каналі комунікації.
        </p>
        <p>
          3.11. Виконавець має право змінювати викладача протягом інтенсиву,
          зокрема щомісяця. Зміна викладача є частиною методичного підходу
          Виконавця та не є підставою для повернення коштів, зменшення вартості
          послуг або пред’явлення претензій.
        </p>
        <h2>4. Учасники інтенсиву та рівень навчання</h2>
        <p>
          4.1. Інтенсив призначений для осіб віком від 16 років та дорослих.
        </p>
        <p>
          4.2. Якщо Отримувач послуг є неповнолітньою особою, Замовником за цим
          Договором виступає один із батьків або інший законний представник
          такої особи.
        </p>
        <p>
          4.3. Інтенсив може проводитися для різних рівневих груп, зокрема
          A1–A2, A2–B1, B1–B2, B1+–B2, B2–C1, C1–C2 або інших рівнів, визначених
          Виконавцем.
        </p>
        <p>
          4.4. Остаточне зарахування Отримувача послуг до відповідної групи
          здійснюється Виконавцем на підставі результатів тестування, анкети,
          співбесіди, комунікації із Замовником/Отримувачем послуг, наявності
          місць у групі та можливості сформувати групу відповідного рівня й
          графіка.
        </p>
        <p>
          4.5. Самостійний вибір рівня Замовником або Отримувачем послуг не
          гарантує остаточного зарахування саме до цього рівня, якщо результати
          тестування або оцінювання Виконавця свідчать про інший фактичний
          рівень володіння англійською мовою.
        </p>
        <p>
          4.6. Виконавець має право запропонувати інший рівень, групу, графік
          або формат навчання, якщо це необхідно для належного надання послуг.
        </p>
        <h2>5. Порядок запису на інтенсив</h2>
        <p>
          5.1. Основний порядок запису на інтенсив здійснюється через сайт
          Виконавця.
        </p>
        <p>
          5.2. Для участі в інтенсиві через сайт Замовник/Отримувач послуг
          проходить тестування, обирає доступний рівень, групу та графік
          навчання, ознайомлюється з умовами цієї Оферти та здійснює оплату
          відповідно до запропонованого способу оплати.
        </p>
        <p>
          5.3. Альтернативно запис на інтенсив може здійснюватися через офіційні
          сторінки або канали Виконавця в Instagram, Telegram, телефоном, email
          або через інші канали комунікації, зазначені Виконавцем.
        </p>
        <p>
          5.4. У разі запису через Instagram, Telegram або інший канал
          комунікації Замовник/Отримувач послуг проходить тестування за
          посиланням або іншим способом, наданим Виконавцем, надсилає або
          повідомляє результати тестування Виконавцю, погоджує з Виконавцем
          рівень, доступний графік і формат навчання, після чого отримує
          реквізити або інструкцію для оплати.
        </p>
        <p>
          5.5. Незалежно від способу запису — через сайт, Instagram, Telegram,
          телефон, email або інший канал комунікації — здійснення Замовником
          повної або часткової оплати вартості інтенсиву означає, що Замовник
          ознайомився з умовами цієї Оферти, погодився з ними, підтвердив
          обраний або погоджений рівень, формат і графік навчання та прийняв
          умови щодо неповернення коштів.
        </p>
        <p>
          5.6. Місце в групі або дуо вважається зарезервованим лише після
          фактичного зарахування коштів на рахунок Виконавця або після
          підтвердження оплати через платіжну систему на сайті, якщо інше прямо
          не погоджено Виконавцем у письмовій формі.
        </p>
        <h2>6. Акцепт Оферти</h2>
        <p>
          6.1. Ця Оферта є публічною пропозицією Виконавця укласти Договір на
          умовах, викладених у цьому документі.
        </p>
        <p>
          6.2. Акцептом цієї Оферти є вчинення Замовником однієї або кількох
          таких дій:
        </p>
        <p>заповнення реєстраційної форми на сайті;</p>
        <p>проходження тестування;</p>
        <p>вибір рівня, групи або графіка;</p>
        <p>
          погодження рівня, формату або графіка в Instagram, Telegram, email,
          телефоном або через інший канал комунікації;
        </p>
        <p>проставлення відмітки про згоду з умовами Оферти;</p>
        <p>здійснення повної або часткової оплати вартості інтенсиву;</p>
        <p>оплата на IBAN ФОП-рахунку Виконавця;</p>
        <p>фактична участь Отримувача послуг у заняттях.</p>
        <p>
          6.3. Основним підтвердженням акцепту Оферти є здійснення Замовником
          повної або часткової оплати вартості інтенсиву.
        </p>
        <p>
          6.4. Здійснення Замовником повної або часткової оплати вартості
          інтенсиву, незалежно від способу оплати, підтверджує повне та
          безумовне прийняття умов цієї Оферти.
        </p>
        <p>
          6.5. Замовник підтверджує, що до моменту оплати він ознайомився з
          умовами цієї Оферти, розуміє її зміст, погоджується з умовами участі в
          інтенсиві, правилами оплати, правилами неповернення коштів, графіком,
          форматом навчання та обсягом послуг.
        </p>
        <h2>7. Вартість послуг та порядок оплати</h2>
        <p>7.1. Вартість участі в інтенсиві становить 23 400 грн.</p>
        <p>
          7.2. Вартість інтенсиву є пакетною вартістю участі в повній сезонній
          програмі та не є оплатою окремих разових занять.
        </p>
        <p>
          7.3. Розрахунок вартості одного заняття, зазначений на сайті або в
          рекламних матеріалах, має інформаційний характер і використовується
          для демонстрації вартості заняття в межах повного пакета.
        </p>
        <p>7.4. Оплата інтенсиву може здійснюватися:</p>
        <p>одним платежем у розмірі 23 400 грн;</p>
        <p>двома частинами по 11 700 грн кожна;</p>
        <p>іншим способом, якщо це прямо погоджено Виконавцем.</p>
        <p>
          7.5. У будь-якому випадку повна вартість інтенсиву має бути сплачена
          до дати початку відповідного сезону інтенсиву, якщо інше прямо не
          погоджено Виконавцем.
        </p>
        <p>
          7.6. Якщо Замовник не сплачує повну вартість інтенсиву до дати початку
          інтенсиву, Виконавець має право не допустити Отримувача послуг до
          занять, не резервувати місце в групі або запропонувати місце іншому
          учаснику.
        </p>
        <p>7.7. Оплата послуг може здійснюватися:</p>
        <p>через сайт Виконавця за допомогою доступного платіжного способу;</p>
        <p>
          шляхом безготівкового переказу коштів на IBAN ФОП-рахунку Виконавця;
        </p>
        <p>іншим способом, наданим або погодженим Виконавцем.</p>
        <p>
          7.8. У разі оплати на IBAN ФОП-рахунку Замовник здійснює платіж за
          реквізитами, наданими Виконавцем через сайт, Instagram, Telegram,
          email або інший канал комунікації.
        </p>
        <p>
          7.9. Обов’язок Замовника з оплати вважається виконаним з моменту
          фактичного зарахування коштів на рахунок Виконавця або підтвердження
          успішної оплати через платіжну систему на сайті.
        </p>
        <p>
          7.10. Банківські комісії, комісії платіжних сервісів або інші платежі
          третіх осіб, пов’язані з оплатою, сплачуються Замовником самостійно,
          якщо інше не погоджено Виконавцем.
        </p>
        <h2>8. Правила неповернення коштів</h2>
        <p>
          8.1. Після здійснення оплати та резервування місця в групі або дуо
          сплачені кошти не повертаються у разі:
        </p>
        <p>відмови Замовника або Отримувача послуг від участі в інтенсиві;</p>
        <p>зміни особистих обставин Замовника або Отримувача послуг;</p>
        <p>
          неправильного вибору графіка, рівня або формату навчання
          Замовником/Отримувачем послуг;
        </p>
        <p>
          неможливості відвідувати заняття за самостійно обраним або погодженим
          графіком;
        </p>
        <p>пропуску занять;</p>
        <p>нерегулярного відвідування;</p>
        <p>невиконання домашніх завдань;</p>
        <p>
          дострокового припинення участі в інтенсиві з ініціативи Замовника або
          Отримувача послуг;
        </p>
        <p>
          незадоволення суб’єктивними очікуваннями щодо темпу, складності, стилю
          викладання або особистого результату, якщо Виконавець належним чином
          надає послуги відповідно до цієї Оферти.
        </p>
        <p>
          8.2. Сплачені кошти не підлягають поверненню також у випадку, якщо
          Отримувач послуг не скористався наданою можливістю відвідувати
          заняття, переглядати записи, виконувати домашні завдання або проходити
          фінальне тестування.
        </p>
        <p>
          8.3. Єдиним спеціальним винятком із правила неповернення коштів є
          ситуація, коли Виконавець не сформував групу відповідного рівня,
          графіка або сезону, запропонував Замовнику альтернативний формат
          навчання, зокрема дуо-формат, а Замовник відмовився від такого
          альтернативного формату. У такому випадку Виконавець повертає
          Замовнику сплачені кошти.
        </p>
        <p>
          8.4. Повернення коштів також може здійснюватися в інших випадках,
          прямо передбачених законодавством України.
        </p>
        <p>
          8.5. У разі повернення коштів банківські комісії, комісії платіжних
          сервісів або інші витрати третіх осіб можуть бути утримані із суми
          повернення, якщо такі витрати були фактично понесені та не залежать
          від Виконавця.
        </p>
        <h2>9. Графік занять та зміна групи</h2>
        <p>
          9.1. Графік занять обирається Замовником/Отримувачем послуг під час
          запису через сайт або погоджується з Виконавцем через Instagram,
          Telegram, email, телефон або інший канал комунікації.
        </p>
        <p>
          9.2. Обраний або погоджений графік є істотною умовою участі в
          інтенсиві.
        </p>
        <p>
          9.3. Замовник несе відповідальність за правильність вибору графіка та
          можливість Отримувача послуг відвідувати заняття у відповідний час.
        </p>
        <p>
          9.4. Неможливість Отримувача послуг відвідувати заняття за самостійно
          обраним або погодженим графіком не є підставою для повернення коштів,
          зменшення вартості інтенсиву, індивідуального перенесення занять або
          надання додаткових занять.
        </p>
        <p>
          9.5. Після формування групи та/або початку інтенсиву переведення
          Отримувача послуг до іншої групи не гарантується.
        </p>
        <p>
          9.6. Переведення до іншої групи можливе лише за наявності вільних
          місць, відповідного рівня, сумісного графіка та окремого погодження
          Виконавця.
        </p>
        <p>
          9.7. Виконавець має право змінювати графік занять у разі об’єктивної
          необхідності, зокрема через технічні причини, хворобу викладача,
          форс-мажорні обставини, повітряну тривогу, відсутність електроенергії,
          інтернет-зв’язку або інші обставини, що унеможливлюють проведення
          заняття у запланований час.
        </p>
        <p>
          9.8. У разі скасування або перенесення заняття з ініціативи Виконавця
          таке заняття переноситься на інший час або компенсується іншим
          способом, визначеним Виконавцем.
        </p>
        <h2>10. Пропуски занять</h2>
        <p>
          10.1. Якщо Отримувач послуг пропускає заняття з власних причин, таке
          заняття вважається наданим, якщо воно було проведене Виконавцем
          відповідно до графіка.
        </p>
        <p>
          10.2. Пропущене з ініціативи або з причин Отримувача послуг заняття не
          переноситься індивідуально, не компенсується додатковим заняттям і не
          є підставою для повернення коштів або зменшення вартості інтенсиву.
        </p>
        <p>
          10.3. Для самостійного опрацювання пропущеного матеріалу Виконавець
          може надати доступ до запису заняття, навчальних матеріалів та/або
          домашнього завдання, якщо це передбачено технічними та організаційними
          можливостями Виконавця.
        </p>
        <p>
          10.4. Невикористання Отримувачем послуг записів занять або матеріалів
          не є підставою для повернення коштів.
        </p>
        <h2>11. Записи занять та навчальні матеріали</h2>
        <p>
          11.1. Заняття в межах інтенсиву записуються або можуть записуватися
          Виконавцем з навчальною, організаційною та методичною метою.
        </p>
        <p>
          11.2. Записи занять надаються для того, щоб учасники могли повторити
          матеріал або наздогнати пропущене заняття.
        </p>
        <p>
          11.3. Доступ до записів занять та матеріалів на платформі надається на
          період проведення відповідного інтенсиву та припиняється після
          завершення сезону інтенсиву, якщо інше окремо не погоджено Виконавцем.
        </p>
        <p>
          11.4. Доступ до записів може надаватися лише учасникам відповідної
          групи або дуо, представникам Виконавця, викладачам, адміністраторам
          або іншим особам, залученим Виконавцем до організації навчального
          процесу.
        </p>
        <p>11.5. Замовнику та Отримувачу послуг забороняється:</p>
        <p>копіювати записи занять;</p>
        <p>
          завантажувати записи, якщо така можливість прямо не надана Виконавцем;
        </p>
        <p>передавати записи третім особам;</p>
        <p>
          публікувати записи або їх фрагменти в соціальних мережах, месенджерах,
          на сайтах або інших ресурсах;
        </p>
        <p>використовувати записи в комерційних цілях;</p>
        <p>
          здійснювати власний аудіо-, фото- або відеозапис заняття без
          попередньої згоди Виконавця.
        </p>
        <p>
          11.6. Передача доступу до платформи, записів, матеріалів або
          навчальних ресурсів третім особам заборонена.
        </p>
        <p>
          11.7. У разі порушення цього розділу Виконавець має право обмежити або
          припинити доступ Замовника/Отримувача послуг до записів, матеріалів
          або занять без повернення коштів.
        </p>
        <h2>12. Домашні завдання, фідбек та фінальне тестування</h2>
        <p>
          12.1. У межах інтенсиву Виконавець забезпечує надання домашніх завдань
          відповідно до програми курсу.
        </p>
        <p>
          12.2. Домашні завдання можуть задаватися на дні, у які немає занять,
          або в інший спосіб, визначений викладачем.
        </p>
        <p>
          12.3. Домашні завдання перевіряються викладачем відповідно до
          програми, формату групи, характеру завдання та організаційних
          можливостей Виконавця.
        </p>
        <p>
          12.4. Формат, обсяг і строк надання фідбеку визначаються Виконавцем
          або викладачем залежно від програми, навантаження групи та характеру
          завдання.
        </p>
        <p>
          12.5. Викладач може надавати фідбек у межах заняття, після заняття, у
          навчальному каналі групи, на платформі або іншим способом, визначеним
          Виконавцем.
        </p>
        <p>
          12.6. У межах інтенсиву Виконавець організовує фінальне тестування.
        </p>
        <p>
          12.7. Проходження фінального тестування є умовою отримання
          внутрішнього сертифіката Profound English Community.
        </p>
        <p>
          12.8. Непроходження фінального тестування, незадовільний результат
          тестування або відмова від участі у тестуванні не є підставою для
          повернення коштів.
        </p>
        <h2>13. Сертифікат</h2>
        <p>
          13.1. За умови завершення програми інтенсиву та проходження фінального
          тестування Отримувач послуг може отримати внутрішній сертифікат
          Profound English Community.
        </p>
        <p>
          13.2. Сертифікат підтверджує участь в інтенсиві та/або завершення
          відповідної програми згідно з внутрішніми правилами Виконавця.
        </p>
        <p>
          13.3. Сертифікат Profound English Community не є документом державного
          зразка, не підтверджує здобуття формальної освіти, не є сертифікатом,
          акредитованим або визнаним Міністерством освіти і науки України, та не
          гарантує автоматичного підтвердження рівня володіння англійською мовою
          третіми особами.
        </p>
        <p>
          13.4. Сертифікат не гарантує досягнення конкретного рівня CEFR,
          конкретного балу на міжнародному іспиті або іншого зовнішнього
          результату.
        </p>
        <h2>14. Speaking Club та додаткові послуги</h2>
        <p>
          14.1. Участь у Speaking Club не входить до вартості інтенсиву та не є
          частиною 52 занять.
        </p>
        <p>
          14.2. Виконавець може надавати Замовнику знижку 25% на участь у
          Speaking Club за умови повної оплати вартості інтенсиву одним
          платежем.
        </p>
        <p>
          14.3. Така знижка є додатковою маркетинговою пропозицією та не
          підлягає грошовій компенсації, поверненню, обміну або перенесенню,
          якщо інше прямо не погоджено Виконавцем.
        </p>
        <p>14.4. Умови участі у Speaking Club можуть визначатися окремо.</p>
        <h2>15. Освітній результат та маркетингові формулювання</h2>
        <p>
          15.1. Виконавець зобов’язується забезпечити організацію та проведення
          занять, доступ до навчальних матеріалів, надання домашніх завдань,
          перевірку завдань, доступ до записів занять на період інтенсиву,
          організацію фінального тестування та інші послуги, передбачені цією
          Офертою.
        </p>
        <p>
          15.2. Виконавець не гарантує досягнення Отримувачем послуг конкретного
          рівня CEFR, конкретного балу на міжнародному іспиті, повного усунення
          мовного бар’єру, конкретного кар’єрного, академічного або особистого
          результату.
        </p>
        <p>
          15.3. Результат навчання залежить від початкового рівня Отримувача
          послуг, регулярності відвідування занять, виконання домашніх завдань,
          активності на заняттях, самостійної роботи, індивідуальних
          особливостей та інших факторів, які не повністю залежать від
          Виконавця.
        </p>
        <p>
          15.4. Формулювання на сайті або в рекламних матеріалах на кшталт “в 3
          рази швидше”, “пройти рівень”, “подолати страх говорити”, “стати
          впевненішим у спілкуванні” та інші подібні формулювання є
          маркетинговими описами інтенсивності, мети або спрямованості програми
          та не є гарантією досягнення конкретного результату кожним учасником.
        </p>
        <p>
          15.5. Формулювання “в 3 рази швидше” використовується як маркетингове
          позначення інтенсивності програми порівняно зі стандартним темпом
          навчання, а саме більшої кількості занять протягом коротшого періоду,
          і не є гарантією прогресу в 3 рази або автоматичного переходу на
          наступний рівень.
        </p>
        <p>
          15.6. Формулювання “пройдемо один рівень від початку до кінця” означає
          проходження навчальної програми відповідного рівня або рівневого
          діапазону, але не гарантує автоматичного переходу Отримувача послуг на
          наступний рівень.
        </p>
        <h2>16. Права та обов’язки Виконавця</h2>
        <p>16.1. Виконавець зобов’язується:</p>
        <p>16.1.1. Надати послуги відповідно до умов цієї Оферти.</p>
        <p>16.1.2. Організувати проведення занять у межах інтенсиву.</p>
        <p>
          16.1.3. Забезпечити доступ до навчальних матеріалів, якщо це
          передбачено програмою.
        </p>
        <p>
          16.1.4. Забезпечити перевірку домашніх завдань відповідно до програми
          та формату інтенсиву.
        </p>
        <p>16.1.5. Організувати фінальне тестування.</p>
        <p>
          16.1.6. Надати внутрішній сертифікат за умови завершення програми та
          проходження фінального тестування.
        </p>
        <p>
          16.1.7. Повідомляти Замовника/Отримувача послуг про істотні
          організаційні зміни, якщо такі виникають.
        </p>
        <p>16.2. Виконавець має право:</p>
        <p>
          16.2.1. Самостійно визначати програму, методику, викладачів, навчальні
          матеріали, платформи та інструменти для проведення інтенсиву.
        </p>
        <p>16.2.2. Змінювати викладача протягом інтенсиву.</p>
        <p>16.2.3. Визначати остаточний рівень групи для Отримувача послуг.</p>
        <p>
          16.2.4. Відмовити у зарахуванні до конкретної групи, якщо рівень
          Отримувача послуг не відповідає рівню групи або якщо в групі немає
          вільних місць.
        </p>
        <p>
          16.2.5. Пропонувати альтернативний формат навчання, зокрема
          дуо-формат, якщо група не сформована.
        </p>
        <p>
          16.2.6. Обмежити або припинити доступ до занять, матеріалів або
          записів у разі порушення Замовником/Отримувачем послуг умов цієї
          Оферти.
        </p>
        <p>
          16.2.7. Не допускати Отримувача послуг до занять у разі несплати
          повної вартості інтенсиву до дати початку інтенсиву.
        </p>
        <p>
          16.2.8. Змінювати організаційні умови проведення інтенсиву, якщо це
          необхідно для належного надання послуг.
        </p>
        <h2>17. Права та обов’язки Замовника і Отримувача послуг</h2>
        <p>17.1. Замовник зобов’язується:</p>
        <p>17.1.1. Ознайомитися з умовами цієї Оферти до здійснення оплати.</p>
        <p>
          17.1.2. Надати достовірну інформацію під час реєстрації, тестування та
          комунікації з Виконавцем.
        </p>
        <p>
          17.1.3. Самостійно обрати або погодити графік навчання до здійснення
          оплати.
        </p>
        <p>
          17.1.4. Своєчасно та в повному обсязі оплатити вартість інтенсиву.
        </p>
        <p>
          17.1.5. Забезпечити наявність у Отримувача послуг технічної можливості
          брати участь в онлайн-заняттях.
        </p>
        <p>
          17.1.6. Не передавати доступ до занять, платформи, записів або
          матеріалів третім особам.
        </p>
        <p>
          17.1.7. Дотримуватися правил поведінки, визначених цією Офертою та
          Виконавцем.
        </p>
        <p>17.2. Отримувач послуг зобов’язується:</p>
        <p>17.2.1. Відвідувати заняття відповідно до погодженого графіка.</p>
        <p>17.2.2. Брати активну участь у заняттях.</p>
        <p>17.2.3. Виконувати домашні завдання.</p>
        <p>
          17.2.4. Поважати викладачів, інших учасників групи та представників
          Виконавця.
        </p>
        <p>17.2.5. Не здійснювати запис занять без дозволу Виконавця.</p>
        <p>
          17.2.6. Не поширювати навчальні матеріали, записи або доступи третім
          особам.
        </p>
        <p>17.3. Замовник має право:</p>
        <p>17.3.1. Отримати послуги відповідно до умов цієї Оферти.</p>
        <p>17.3.2. Отримувати інформацію про організаційні умови інтенсиву.</p>
        <p>
          17.3.3. Звертатися до Виконавця з організаційними питаннями через
          офіційні канали комунікації.
        </p>
        <p>
          17.3.4. Отримати повернення коштів лише у випадках, прямо передбачених
          цією Офертою або законодавством України.
        </p>
        <h2>18. Технічні умови участі</h2>
        <p>
          18.1. Замовник/Отримувач послуг самостійно забезпечує наявність
          справного пристрою, доступу до мережі Інтернет, камери, мікрофона,
          навушників та програмного забезпечення, необхідного для участі в
          онлайн-заняттях.
        </p>
        <p>
          18.2. Якщо заняття не відбулося або було перерване для Отримувача
          послуг через технічні проблеми на стороні Замовника/Отримувача послуг,
          таке заняття вважається проведеним, якщо Виконавець був готовий надати
          послугу та заняття проводилося відповідно до графіка.
        </p>
        <p>
          18.3. Технічні проблеми на стороні Замовника/Отримувача послуг не є
          підставою для повернення коштів, перенесення заняття або надання
          додаткового заняття.
        </p>
        <p>
          18.4. Якщо заняття не може бути проведене через технічні проблеми на
          стороні Виконавця, Виконавець переносить заняття або компенсує його
          іншим способом, визначеним Виконавцем.
        </p>
        <h2>19. Правила поведінки</h2>
        <p>
          19.1. Під час участі в інтенсиві Замовник та Отримувач послуг
          зобов’язані дотримуватися етичної, поважної та безпечної комунікації.
        </p>
        <p>19.2. Забороняється:</p>
        <p>ображати викладачів, інших учасників або представників Виконавця;</p>
        <p>
          використовувати дискримінаційні, агресивні, принизливі, сексуалізовані
          або образливі висловлювання;
        </p>
        <p>перешкоджати проведенню занять;</p>
        <p>поширювати матеріали, записи або доступи третім особам;</p>
        <p>здійснювати запис занять без дозволу Виконавця;</p>
        <p>
          використовувати заняття або матеріали в комерційних цілях без згоди
          Виконавця;
        </p>
        <p>порушувати правила відповідної платформи або навчального каналу.</p>
        <p>
          19.3. У разі порушення правил поведінки Виконавець має право
          попередити Замовника/Отримувача послуг, тимчасово обмежити участь у
          заняттях або припинити доступ до інтенсиву без повернення коштів.
        </p>
        <h2>20. Інтелектуальна власність</h2>
        <p>
          20.1. Навчальні матеріали, програми, записи занять, презентації,
          завдання, тести, методичні матеріали, тексти та інші об’єкти, створені
          Виконавцем або на замовлення Виконавця, є об’єктами права
          інтелектуальної власності Виконавця.
        </p>
        <p>
          20.2. Матеріали третіх осіб використовуються відповідно до умов
          відповідних правовласників або платформ.
        </p>
        <p>
          20.3. Замовник та Отримувач послуг мають право використовувати надані
          матеріали виключно для особистого навчання в межах інтенсиву.
        </p>
        <p>
          20.4. Забороняється копіювати, поширювати, продавати, передавати,
          публікувати, змінювати або використовувати матеріали Виконавця в
          комерційних цілях без письмової згоди Виконавця.
        </p>
        <p>
          20.5. Порушення прав інтелектуальної власності Виконавця може бути
          підставою для припинення доступу до інтенсиву без повернення коштів та
          застосування інших способів захисту прав Виконавця.
        </p>
        <h2>21. Персональні дані</h2>
        <p>
          21.1. Акцептуючи цю Оферту, Замовник надає Виконавцю згоду на обробку
          персональних даних Замовника та/або Отримувача послуг з метою
          організації та надання послуг за цим Договором.
        </p>
        <p>
          21.2. До персональних даних можуть належати: ім’я, прізвище, номер
          телефону, email, Telegram/Instagram-контакт, вік, рівень англійської
          мови, результати тестування, інформація про оплату, інформація про
          участь у заняттях, виконання домашніх завдань та інші дані, необхідні
          для надання послуг.
        </p>
        <p>21.3. Персональні дані обробляються з метою:</p>
        <p>запису на інтенсив;</p>
        <p>проведення тестування;</p>
        <p>визначення рівня;</p>
        <p>формування груп;</p>
        <p>організації графіка;</p>
        <p>проведення занять;</p>
        <p>надання доступу до платформи;</p>
        <p>перевірки домашніх завдань;</p>
        <p>комунікації із Замовником/Отримувачем послуг;</p>
        <p>здійснення оплати;</p>
        <p>видачі сертифіката;</p>
        <p>виконання цього Договору.</p>
        <p>
          21.4. Виконавець може передавати персональні дані викладачам,
          адміністраторам, технічним спеціалістам, платіжним сервісам,
          платформам або іншим особам, залученим до організації та надання
          послуг, виключно в обсязі, необхідному для виконання цього Договору.
        </p>
        <p>
          21.5. Замовник підтверджує, що у разі надання персональних даних
          неповнолітньої особи він має право надавати такі дані та діє як
          законний представник такої особи.
        </p>
        <p>
          21.6. Замовник має право звернутися до Виконавця з питань доступу,
          уточнення або видалення персональних даних відповідно до законодавства
          України.
        </p>
        <h2>22. Фото-, відео- та аудіозапис</h2>
        <p>
          22.1. Заняття можуть записуватися Виконавцем з навчальною, методичною
          та організаційною метою.
        </p>
        <p>
          22.2. Участь Отримувача послуг у заняттях означає розуміння та згоду
          Замовника/Отримувача послуг із тим, що заняття можуть бути записані
          для подальшого навчального використання учасниками відповідної групи
          або дуо.
        </p>
        <p>
          22.3. Використання зображення, голосу, імені або відеозапису
          Отримувача послуг у рекламних, маркетингових матеріалах, соціальних
          мережах або на сайті Виконавця здійснюється лише за окремою згодою
          Замовника або Отримувача послуг, якщо така згода є необхідною
          відповідно до законодавства.
        </p>
        <p>
          22.4. Записи занять не призначені для публічного поширення та
          використовуються лише в межах навчального процесу, якщо інше окремо не
          погоджено сторонами.
        </p>
        <h2>23. Комунікація між Сторонами</h2>
        <p>
          23.1. Офіційними каналами комунікації між Сторонами є сайт Виконавця,
          email, Telegram, Instagram, телефонний зв’язок та інші канали,
          зазначені або погоджені Виконавцем.
        </p>
        <p>
          23.2. Повідомлення, надіслані через зазначені канали, можуть
          використовуватися для погодження рівня, графіка, формату навчання,
          реквізитів для оплати, організаційних питань, доступу до навчальних
          матеріалів та інших умов участі в інтенсиві.
        </p>
        <p>
          23.3. Юридично значущі повідомлення бажано надсилати на email
          Виконавця або в офіційний Telegram-акаунт Виконавця.
        </p>
        <p>
          23.4. Замовник зобов’язується самостійно перевіряти повідомлення від
          Виконавця у погоджених каналах комунікації.
        </p>
        <p>
          23.5. Якщо Замовник не ознайомився з повідомленням Виконавця з причин,
          що залежать від Замовника, таке неознайомлення не звільняє Замовника
          від виконання умов цього Договору.
        </p>
        <h2>24. Форс-мажор та обставини, що ускладнюють проведення занять</h2>
        <p>
          24.1. Сторони звільняються від відповідальності за повне або часткове
          невиконання зобов’язань, якщо таке невиконання стало наслідком
          обставин непереборної сили або інших обставин, які сторони не могли
          передбачити чи запобігти.
        </p>
        <p>
          24.2. До таких обставин можуть належати: воєнні дії, повітряні
          тривоги, відсутність електроенергії, перебої інтернет-зв’язку,
          технічні збої платформ, хвороба викладача, рішення органів влади,
          надзвичайні ситуації, стихійні лиха та інші обставини, які об’єктивно
          унеможливлюють проведення занять у запланований час.
        </p>
        <p>
          24.3. У разі виникнення таких обставин Виконавець має право перенести
          заняття, змінити платформу, змінити викладача, змінити графік або
          запропонувати інший спосіб надання послуг.
        </p>
        <p>
          24.4. Тимчасове перенесення заняття або зміна організаційних умов у
          зв’язку з такими обставинами не є підставою для повернення коштів.
        </p>
        <h2>25. Відповідальність Сторін</h2>
        <p>
          25.1. Виконавець несе відповідальність за надання послуг у межах та на
          умовах, визначених цією Офертою.
        </p>
        <p>25.2. Виконавець не несе відповідальності за:</p>
        <p>
          неможливість Отримувача послуг відвідувати заняття з особистих причин;
        </p>
        <p>неправильний вибір графіка Замовником/Отримувачем послуг;</p>
        <p>технічні проблеми на стороні Замовника/Отримувача послуг;</p>
        <p>невиконання домашніх завдань Отримувачем послуг;</p>
        <p>нерегулярне відвідування занять;</p>
        <p>
          суб’єктивне незадоволення результатом за умови належного надання
          послуг;
        </p>
        <p>
          неможливість досягнення конкретного рівня або результату через
          фактори, що не залежать від Виконавця.
        </p>
        <p>
          25.3. Замовник несе відповідальність за достовірність наданої
          інформації, своєчасність оплати, дотримання умов цієї Оферти та
          поведінку Отримувача послуг, якщо Отримувачем є неповнолітня особа.
        </p>
        <p>
          25.4. У разі порушення Замовником або Отримувачем послуг умов цієї
          Оферти Виконавець має право обмежити або припинити надання послуг без
          повернення коштів.
        </p>
        <h2>26. Строк дії Договору та припинення участі</h2>
        <p>
          26.1. Цей Договір набирає чинності з моменту акцепту Оферти Замовником
          та діє до повного виконання Сторонами своїх зобов’язань.
        </p>
        <p>
          26.2. Участь Отримувача послуг в інтенсиві триває протягом
          відповідного сезону інтенсиву.
        </p>
        <p>
          26.3. Доступ до занять, записів та матеріалів припиняється після
          завершення відповідного сезону інтенсиву, якщо інше окремо не
          погоджено Виконавцем.
        </p>
        <p>
          26.4. Замовник має право припинити участь в інтенсиві з власної
          ініціативи, однак таке припинення не є підставою для повернення
          коштів.
        </p>
        <p>
          26.5. Виконавець має право припинити доступ Отримувача послуг до
          інтенсиву у разі істотного або повторного порушення умов цієї Оферти
          без повернення коштів.
        </p>
        <h2>27. Зміни до Оферти</h2>
        <p>
          27.1. Виконавець має право вносити зміни до цієї Оферти шляхом
          розміщення нової редакції на сайті або повідомлення Замовників іншим
          способом.
        </p>
        <p>
          27.2. Зміни до Оферти не впливають на вже оплачені умови участі в
          конкретному сезоні інтенсиву, якщо інше не передбачено законодавством
          України або прямо не погоджено сторонами.
        </p>
        <p>
          27.3. Нова редакція Оферти застосовується до нових акцептів,
          здійснених після її оприлюднення.
        </p>
        <h2>28. Вирішення спорів</h2>
        <p>
          28.1. Усі спори та розбіжності, що виникають між Сторонами,
          вирішуються шляхом переговорів.
        </p>
        <p>
          28.2. Замовник може звернутися до Виконавця з письмовим зверненням
          через email або інший офіційний канал комунікації.
        </p>
        <p>
          28.3. У разі неможливості вирішити спір шляхом переговорів, спір
          вирішується відповідно до законодавства України.
        </p>
        <h2>29. Реквізити та контактні дані Виконавця</h2>
        <p>
          <strong>Фізична особа-підприємець:</strong>
          <br />
          Кошкіна Марія Михайлівна
        </p>
        <p>
          <strong>РНОКПП:</strong>
          <br />
          3824501160
        </p>
        <p>
          <strong>Місцезнаходження:</strong>
          <br />
          м. Кропивницький, Кіровоградська область, Україна
        </p>
        <p>
          <strong>Державна реєстрація:</strong>
          <br />
          Фізична особа-підприємець Кошкіна Марія Михайлівна діє на підставі
          державної реєстрації в Єдиному державному реєстрі юридичних осіб,
          фізичних осіб-підприємців та громадських формувань, запис №
          2010350000000734554 від 25 лютого 2025 року.
        </p>
        <p>
          <strong>Банківські реквізити:</strong>
          <br />
          IBAN: UA183220010000026006350052194
          <br />
          Банк: Акціонерне товариство «УНІВЕРСАЛ БАНК»
        </p>
        <p>
          <strong>Email:</strong>
          <br />
          profoundenglishcommunity@gmail.com
        </p>
        <p>
          <strong>Telegram:</strong>
          <br />
          @profoundeng
        </p>
        <p>
          <strong>Телефон:</strong>
          <br />
          +380 99 715 35 40
        </p>
        <p>
          <strong>Instagram:</strong>
          <br />
          @profoundenglishcommunity
        </p>
        <p>
          <strong>Посилання на Instagram:</strong>
          <br />
          <a href="https://www.instagram.com/profoundenglishcommunity">
            <u>https://www.instagram.com/profoundenglishcommunity</u>
          </a>
        </p>
      </div>
      <Footer />
    </div>
  );
}
